export const subscriptionStatus = [
  {
    value: 1,
    label: 'Active',
  },
  {
    value: 2,
    label: 'Inactive',
  },
  {
    value: 3,
    label: 'Cancel'
  },
]

export const getSubscriptionStatusLabel = (value) => {
  if (value*1 == 1) return 'Active'
  if (value*1 == 2) return 'Inactive'
  if (value*1 == 3) return 'Cancel'
}